// 1222.12 * 100 = 122211.99999999999
const stringToPrice = (priceStr) => {
  return parseInt((Number(priceStr).toFixed(2) * 100).toFixed())
}

export default stringToPrice



// WEBPACK FOOTER //
// ./src/utils/stringToPrice.js